import React from 'react'
import styled from '@emotion/styled'
import { Select, Button, Input } from 'antd'
import { StringParam, useQueryParams } from 'use-query-params'
import { useGlobalConfig } from 'context/config-context'
import { StyledSelect } from 'components'
import { elements, colors } from 'style/theme'

const { Option } = Select
const { Search } = Input

const StyledFiltersHeader = styled.div({
	margin: '25px 0'
})
const StyledFiltersBar = styled.div({
	display: 'grid',
	height: 42,
	gridTemplateColumns: '1fr 600px',
	gridGap: 20
})

const StyledFilters = styled.div({
	background: colors.brandWhite,
	border: elements.brandBorder,
	borderRadius: elements.brandBorderRadius,
	display: 'grid',
	gridTemplateColumns: '98px 1fr 1fr 145px'
})

const FilterItem = styled.div({
	borderRight: elements.brandBorder,
	height: 42,
	display: 'grid',
	alignItems: 'center',
	textAlign: 'center'
})

const ResetFiltersButton = styled(Button)({
	color: '#EA0234',
	fontSize: 14,
	height: 42,
	width: '100%',
	background: 'transparent',
	border: 'none'
})

const renderOptions = (list, name) =>
	list.map(item => (
		<Option key={item} value={item} name={name}>
			{item}
		</Option>
	))

const ScanSettingsListFilters = ({ onSearch, onFilterChange }) => {
	const config = useGlobalConfig()
	const types = config['scan-settings-types']
	const owners = config['scan-settings-owners']

	const [query, setQuery] = useQueryParams({
		search: StringParam,
		type: StringParam,
		owner: StringParam
	})
	const { search, type, owner } = query

	const resetFilters = () =>
		setQuery({
			search: null,
			type: null,
			owner: null
		})

	return (
		<StyledFiltersHeader>
			<StyledFiltersBar>
				<Search placeholder="SEARCH" onChange={onSearch} allowClear value={search || undefined} />
				<StyledFilters>
					<FilterItem>FILTER BY</FilterItem>
					<FilterItem>
						<StyledSelect
							name="type"
							onChange={onFilterChange}
							placeholder="TYPE"
							value={type || undefined}
						>
							{renderOptions(types, 'type')}
						</StyledSelect>
					</FilterItem>
					<FilterItem>
						<StyledSelect
							name="owner"
							onChange={onFilterChange}
							placeholder="OWNER"
							value={owner || undefined}
						>
							{renderOptions(owners, 'owner')}
						</StyledSelect>
					</FilterItem>

					<ResetFiltersButton icon="undo" onClick={resetFilters}>
						Reset Filters
					</ResetFiltersButton>
				</StyledFilters>

			</StyledFiltersBar>
		</StyledFiltersHeader>
	)
}

export default ScanSettingsListFilters
